module.exports = __webpack_public_path__ + "static/media/WeatherPlus_Profile_VI.5c586c1b.pdf";